import { useState, useMemo } from 'react';
import { inferTableStructure } from '../../utils/tableInference';
import PreviewTable from './PreviewTable';

function ComboMappingPanel({ columns, rows, initialMapping, onConfirm, onBack, ui }) {
  const numericColumns = columns.filter((c) => c.type === 'number');
  const inferred = useMemo(() => inferTableStructure(rows, columns, 'combo'), [rows, columns]);

  const [categoryCol, setCategoryCol] = useState(initialMapping.category || '');
  const [barCol, setBarCol] = useState(initialMapping.barValue || '');
  const [lineCol, setLineCol] = useState(initialMapping.lineValue || '');

  const canConfirm = Boolean(categoryCol) && Boolean(barCol) && Boolean(lineCol) && barCol !== lineCol;

  const handleConfirm = () => {
    onConfirm({ category: categoryCol, barValue: barCol, lineValue: lineCol });
  };

  const availableNumeric = numericColumns.filter((c) => c.name !== categoryCol);

  return (
    <div>
      {inferred?.notes && (
        <div className="border p-2.5 mb-3 text-xs leading-relaxed" style={{ color: ui.textSecondary, borderColor: ui.borderSecondary, backgroundColor: ui.bgSecondary }}>
          <span className="font-medium" style={{ color: ui.text }}>Auto-detected: </span>{inferred.notes}
        </div>
      )}
      <div className="grid gap-3 mb-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
        <label className="text-xs" style={{ color: ui.text }}>
          <div className="mb-1 font-medium">Label column</div>
          <select value={categoryCol} onChange={(e) => setCategoryCol(e.target.value)} className="w-full text-xs border py-1 px-2" style={{ borderColor: ui.borderSecondary }}>
            <option value="">Select a column</option>
            {columns.map((c) => (
              <option key={c.name} value={c.name}>{c.name} ({c.type === 'number' ? '#' : 'abc'})</option>
            ))}
          </select>
        </label>
      </div>
      <div className="grid gap-3 mb-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
        <label className="text-xs" style={{ color: ui.text }}>
          <div className="mb-1 font-medium">Bar values (left axis)</div>
          <select value={barCol} onChange={(e) => setBarCol(e.target.value)} className="w-full text-xs border py-1 px-2" style={{ borderColor: ui.borderSecondary }}>
            <option value="">Select a column</option>
            {availableNumeric.map((c) => <option key={c.name} value={c.name}>{c.name}</option>)}
          </select>
        </label>
        <label className="text-xs" style={{ color: ui.text }}>
          <div className="mb-1 font-medium">Line values (right axis)</div>
          <select value={lineCol} onChange={(e) => setLineCol(e.target.value)} className="w-full text-xs border py-1 px-2" style={{ borderColor: ui.borderSecondary }}>
            <option value="">Select a column</option>
            {availableNumeric.filter((c) => c.name !== barCol).map((c) => <option key={c.name} value={c.name}>{c.name}</option>)}
          </select>
        </label>
      </div>
      <PreviewTable columns={columns} rows={rows} ui={ui} />
      <div className="flex gap-2">
        <button onClick={onBack} className="flex-1 text-xs border py-2 ui-hover ui-border" style={{ borderColor: ui.border, color: ui.text }}>&larr; Back</button>
        <button onClick={handleConfirm} disabled={!canConfirm} className={`flex-1 text-xs border py-2 font-medium ui-border ${!canConfirm ? 'opacity-40 cursor-not-allowed' : 'ui-hover'}`} style={{ borderColor: ui.border, color: ui.text }}>
          Confirm &rarr;
        </button>
      </div>
    </div>
  );
}

export default ComboMappingPanel;
